import * as classes from "./header.module.scss";
import Logo from "../../icons/CBCA.svg";
import MoreIcon from "../../icons/More.svg";
import content from "../../content.json";
import { useContext, useEffect } from "react";
import {
  ActionType,
  AppContext,
  ModalType,
  ViewMode,
  World,
} from "../../contexts/AppContext";
import Button from "../Button/Button";
import classNames from "classnames";

const Header = () => {
  const { state, dispatch } = useContext(AppContext);
  const { world, modal, viewMode, isWorldLoading, isMenuOpen } = state;

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        console.log("B");
        dispatch({ type: ActionType.SetWorld, value: null });
      }
    };
    if (modal === null && world !== null && !isWorldLoading) {
      window.addEventListener("keydown", onKeyDown);
    }

    return () => window.removeEventListener("keydown", onKeyDown);
  }, [modal, world, isWorldLoading]);

  return (
    <div
      className={classNames(classes.root, {
        [classes["root--hidden"]]: !!modal && modal.type !== ModalType.Look,
      })}
    >
      <h1 style={{ opacity: 0, pointerEvents: "none", position: "absolute" }}>
        Cash by Cash App
      </h1>
      <Logo
        aria-hidden={true}
        className={classes.logo}
        onClick={() =>
          dispatch({
            type: ActionType.SetViewMode,
            value: ViewMode.LandingPage,
          })
        }
      />
      <div
        className={classNames(classes.buttons, {
          [classes["buttons--hidden"]]:
            (!!modal &&
              (modal.type === ModalType.Look ||
                modal.type === ModalType.Manifesto)) ||
            isMenuOpen,
        })}
      >
        {viewMode === ViewMode.World && (
          <Button
            type="button"
            label="Lookbook"
            onClick={() =>
              dispatch({
                type: ActionType.SetViewMode,
                value: ViewMode.Lookbook,
              })
            }
          />
        )}
        {viewMode === ViewMode.Lookbook && (
          <Button
            type="button"
            label="Explore"
            onClick={() =>
              dispatch({
                type: ActionType.SetWorld,
                value: World.FieldTrip,
              })
            }
          />
        )}
        <Button
          type="link"
          href={content.shopUrl}
          label={content.uiCopy.shop}
        />
        <Button
          type="button"
          label="Expanded Menu"
          onClick={() => dispatch({ type: ActionType.ToggleMenu })}
          iconOnly
          icon={<MoreIcon className={classes["more-icon"]} />}
        />
      </div>
    </div>
  );
};

export default Header;
